export class SettingsManager {
    constructor() {
        this.init();
    }

    private init() {
        const menu = document.getElementById('settings-menu');
        document.getElementById('settings-toggle')?.addEventListener('click', () => {
            menu?.classList.toggle('active');
        });

        // Cambio de Paleta
        document.querySelectorAll('.palette-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const pal = (e.currentTarget as HTMLElement).dataset.pal;
                if (pal) document.body.setAttribute('data-palette', pal);
            });
        });

        // Cambio de Forma
        document.querySelectorAll('.shape-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const shape = (e.currentTarget as HTMLElement).dataset.shape;
                if (shape) document.body.setAttribute('data-shape', shape);
            });
        });
    }
}